/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Aug 21 2023
 * @deprecated
 **/

type Component = JSX.Element | null;

interface Props<Condition extends string | number> {
	condition: Condition | null | undefined;
	cases: Partial<Record<Condition, Component>>;
	defaultCase?: Component;
}

/**
 * @example
 * ```tsx
 * const [testValue, setTestValue] = useState(0);
 *
 * <SwitchCase
 * 	condition={testValue}
 * 	cases={{
 * 		0: <Comp1 />,
 * 		1: <Comp2 />,
 *  	2: <Comp3 />
 * 	}}
 * 	defaultCase={<Comp4 />}
 * />
 * ```
 *
 * @param props.condition - 비교 조건
 * @param props.cases - 조건에 부합하면 렌더링될 컴포넌트
 * @param props.defaultCase - 조건에 부합하는 값이 없으면 렌더링할 컴포넌트
 */
export default function SwitchCase<Condition extends string | number>({
	condition,
	cases,
	defaultCase = null
}: Props<Condition>) {
	try {
		if (condition === null || condition === undefined) {
			return defaultCase;
		}

		return cases[condition] ?? defaultCase;
	} catch {
		return defaultCase;
	}
}
